module.exports = __webpack_public_path__ + "img/1640015279080.png.6ab4a4f8.png";